import { AccountNextStep, AccountType } from "./Account";
import { NotifierRoles, roleOptions } from "./Person";
import { DisplayOptions } from "./ui";

export const QuilterAccountTypeOptions = [
  { value: AccountType.IndividualSavingsAccount, label: "Individual Savings Account ISA" },
  { value: AccountType.CollectiveInvestmentBond, label: "Collective Investment Bond (CIB)" },
  { value: AccountType.CollectiveInvestmentAccount, label: " Collective Investment Account (CIA)" },
  { value: AccountType.CashHub, label: " Cash Hub (CHB)" },
  {
    value: AccountType.CollectiveRetirementAccount,
    label: "Collective Retirement Account - Pension (CRA)",
  },
];

export type QuilterAccountTypes =
  | AccountType.IndividualSavingsAccount
  | AccountType.CollectiveInvestmentBond
  | AccountType.CollectiveInvestmentAccount
  | AccountType.CashHub
  | AccountType.CollectiveRetirementAccount;

export type QuilterNextSteps =
  | AccountNextStep.WithdrawalOfFundsToExecutorAccount
  | AccountNextStep.TransferOfOwnershipToBeneficiary
  | AccountNextStep.AdditionalPermittedSubscription
  | AccountNextStep.AssignmentForCIB
  | AccountNextStep.PensionFlexiAccessCRA
  | AccountNextStep.TransferOfOwnershipToExternalProvider;

const WithdrawalOfFundsToExecutorAccount: DisplayOptions<QuilterNextSteps> = {
  value: AccountNextStep.WithdrawalOfFundsToExecutorAccount,
  label: "Withdrawal of funds to an Executor account",
};

const TransferOfOwnershipToExternalProvider: DisplayOptions<QuilterNextSteps> = {
  value: AccountNextStep.TransferOfOwnershipToExternalProvider,
  label: "Transfer of ownership to External Provider",
};

const TransferOfOwnershipToBeneficiary: DisplayOptions<QuilterNextSteps> = {
  value: AccountNextStep.TransferOfOwnershipToBeneficiary,
  label: "Transfer of ownership to a beneficiary",
};

const AdditionalPermittedSubscription: DisplayOptions<QuilterNextSteps> = {
  value: AccountNextStep.AdditionalPermittedSubscription,
  label: "Additional Permitted Subscription (APS)",
};

const AssignmentForCIB: DisplayOptions<QuilterNextSteps> = {
  value: AccountNextStep.AssignmentForCIB,
  label: "Assignment for CIB",
};

const PensionFlexiAccessCRA: DisplayOptions<QuilterNextSteps> = {
  value: AccountNextStep.PensionFlexiAccessCRA,
  label: "Pension Flexi Access CRA",
};

export function nextActionByQuilterAccountType(
  type: QuilterAccountTypes | AccountType
): ReadonlyArray<DisplayOptions<QuilterNextSteps>> {
  switch (type) {
    case AccountType.IndividualSavingsAccount:
      return [
        WithdrawalOfFundsToExecutorAccount,
        TransferOfOwnershipToBeneficiary,
        AdditionalPermittedSubscription,
      ];
    case AccountType.CollectiveInvestmentBond:
      return [
        WithdrawalOfFundsToExecutorAccount,
        TransferOfOwnershipToBeneficiary,
        AssignmentForCIB,
      ];

    case AccountType.CollectiveInvestmentAccount:
      return [WithdrawalOfFundsToExecutorAccount, TransferOfOwnershipToBeneficiary];

    case AccountType.CashHub:
      return [WithdrawalOfFundsToExecutorAccount];

    case AccountType.CollectiveRetirementAccount:
      return [
        WithdrawalOfFundsToExecutorAccount,
        TransferOfOwnershipToExternalProvider,
        PensionFlexiAccessCRA,
      ];

    default:
      return [];
  }
}

export const quilterRoleOptions = roleOptions.concat([
  { value: NotifierRoles.FinancialAdvisor, label: "A Financial Advisor" },
]);
